import React, { useEffect, useState } from 'react';
import './ModernSpeedometer.css';

const ModernSpeedometer = ({ 
  value = 75, 
  maxValue = 100, 
  title = "Performance", 
  unit = "%",
  color = "#4f46e5",
  size = 200 
}) => {
  const [animatedValue, setAnimatedValue] = useState(0);

  useEffect(() => {
    const timer = setTimeout(() => {
      setAnimatedValue(value);
    }, 500);
    return () => clearTimeout(timer);
  }, [value]);

  const percentage = (animatedValue / maxValue) * 100;
  const strokeDasharray = 2 * Math.PI * 85; // circumference
  const strokeDashoffset = strokeDasharray - (strokeDasharray * percentage) / 100;

  const getColorByValue = (val) => {
    if (val < 30) return '#ef4444'; // red
    if (val < 70) return '#f59e0b'; // yellow
    return '#10b981'; // green
  };

  const dynamicColor = color === 'auto' ? getColorByValue(percentage) : color;

  return (
    <div className="modern-speedometer" style={{ width: size, height: size }}>
      <svg width={size} height={size} className="speedometer-svg">
        {/* Background circle */}
        <circle
          cx={size / 2}
          cy={size / 2}
          r="85"
          fill="none"
          stroke="#f1f5f9"
          strokeWidth="12"
        />
        
        {/* Progress circle */}
        <circle
          cx={size / 2}
          cy={size / 2}
          r="85"
          fill="none"
          stroke={dynamicColor}
          strokeWidth="12"
          strokeLinecap="round"
          strokeDasharray={strokeDasharray}
          strokeDashoffset={strokeDashoffset}
          className="progress-circle"
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
        />
        
        {/* Center content */}
        <text
          x={size / 2}
          y={size / 2 + 5}
          textAnchor="middle"
          className="speedometer-value"
          fill={dynamicColor}
        >
          {Math.round(animatedValue)}{unit}
        </text>
      </svg>
      
      <div className="speedometer-title" style={{ color: dynamicColor }}>
        {title}
      </div>
      
      {/* Performance indicators */}
      <div className="performance-indicators">
        <div className={`indicator ${percentage >= 30 ? 'active' : ''}`} style={{ backgroundColor: percentage >= 30 ? '#10b981' : '#e2e8f0' }}></div>
        <div className={`indicator ${percentage >= 60 ? 'active' : ''}`} style={{ backgroundColor: percentage >= 60 ? '#f59e0b' : '#e2e8f0' }}></div>
        <div className={`indicator ${percentage >= 90 ? 'active' : ''}`} style={{ backgroundColor: percentage >= 90 ? '#ef4444' : '#e2e8f0' }}></div>
      </div>
    </div>
  );
};

export default ModernSpeedometer;